import { FC, PropsWithChildren } from "react";
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { IconX } from '@tabler/icons-react';

type ContainerProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
}

const Container: FC<PropsWithChildren<ContainerProps>> = ({ open, setOpen, children }) => {
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-pdf-complice-report"
            >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[90vh] w-[80vw] bg-white border-2 border-black shadow-lg p-2 pt-9 rounded-xl">
                    <div className="relative size-full">
                        <div className="absolute -top-9 -right-2 z-10">
                            <IconButton size="small" classes={{ root: "!bg-white hover:!bg-gray-200" }} >
                                <IconX className="text-inherit" onClick={handleClose} />
                            </IconButton>
                        </div>
                        {children}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default Container;

/* 
    Componente que tiene el contenedor de visualización en este caso un modal para el PDF

    - Daniel Bonilla Septiembre 2025
*/